/* Copyright IBM Corp. 2017 */
import { Layout } from './../../api';

export const DEFAULT_LAYOUT_MODE = 'default';
export const LAYOUT_TYPE_ANGULAR = 'angular';

export const LAYOUT_MODE_NAVIGATION = 'wch-navigation';
export const LAYOUT_MODE_HEADER = 'wch-header';
export const LAYOUT_MODE_FOOTER = 'wch-footer';
export const LAYOUT_MODE_ERROR = 'wch-error';

export const LAYOUT_TEMPLATE_NAVIGATION = 'wch-navigation';
export const LAYOUT_TEMPLATE_HEADER = 'wch-header';
export const LAYOUT_TEMPLATE_FOOTER = 'wch-footer';
export const LAYOUT_TEMPLATE_ERROR = 'wch-error';

export const LAYOUT_NAVIGATION: Layout = {
    templateType: LAYOUT_TYPE_ANGULAR,
    template: LAYOUT_TEMPLATE_NAVIGATION
};

export const LAYOUT_HEADER: Layout = {
    templateType: LAYOUT_TYPE_ANGULAR,
    template: LAYOUT_TEMPLATE_HEADER
};

export const LAYOUT_FOOTER: Layout = {
    templateType: LAYOUT_TYPE_ANGULAR,
    template: LAYOUT_TEMPLATE_FOOTER
};

export const LAYOUT_ERROR: Layout = {
    templateType: LAYOUT_TYPE_ANGULAR,
    template: LAYOUT_TEMPLATE_ERROR
};

export const DEFAULT_LAYOUT_MAPPING: { [layoutMode: string]: Layout } = {};
DEFAULT_LAYOUT_MAPPING[LAYOUT_MODE_NAVIGATION] = LAYOUT_NAVIGATION;
DEFAULT_LAYOUT_MAPPING[LAYOUT_MODE_HEADER] = LAYOUT_HEADER;
DEFAULT_LAYOUT_MAPPING[LAYOUT_MODE_FOOTER] = LAYOUT_FOOTER;
DEFAULT_LAYOUT_MAPPING[LAYOUT_MODE_ERROR] = LAYOUT_ERROR;
